import { createSlice } from "@reduxjs/toolkit";

const data = {
    tiposAntecedentes: [{ id: 0, descripcion: "" }],
    personaAntecedentes: [{
        id: 0,
        idPersona: 0,
        numero: 0,
        idTipoAntecedente: 0,
        antecente: "",
        fechaRegistro: null,
        usuarioRegistro: null,
        fechaModificacion: null,
        usuarioModificacion: null,
    }],
}

export const personPastSlice = createSlice({
    name: "personPast",
    initialState: {},
    reducers: {
        initPersonPast: (state, action) => {
            const { sliceKey } = action.payload;
            if (!state[sliceKey]) state[sliceKey] = JSON.parse(JSON.stringify(data));
        },
        setTiposAntecedentes: (state, action) => {
            const { sliceKey, data } = action.payload;
            state[sliceKey].tiposAntecedentes = data;
        },
        setPersonaAntecedentes: (state, action) => {
            const { sliceKey, data } = action.payload;
            state[sliceKey].personaAntecedentes = data;
        },
        setDatoPersonaAntecedentes: (state, action) => {
            var { sliceKey, numero, name, value } = action.payload;

            if (name.startsWith("id")) value = parseInt(value)

            const index = state[sliceKey].personaAntecedentes.findIndex(item => item.numero === numero);
            state[sliceKey].personaAntecedentes[index][name] = value;
        },
        addPersonaAntecedentes: (state, action) => {
            var sliceKey = action.payload;
            var maxNumero = state[sliceKey].personaAntecedentes.length === 0 ? 0 : Math.max.apply(null, state[sliceKey].personaAntecedentes.map((item) => { return item.numero; }))

            state[sliceKey].personaAntecedentes.push(defaultPersonaAntecedentes.map((item) => { return { ...item, numero: maxNumero + 1 } })[0]);
        },
        removePersonaAntecedentes: (state, action) => {
            const { sliceKey, numero } = action.payload;
            state[sliceKey].personaAntecedentes = state[sliceKey].personaAntecedentes.filter(item => item.numero !== numero)
        },
    },
});

export const { initPersonPast, setTiposAntecedentes, setPersonaAntecedentes, setDatoPersonaAntecedentes
    , addPersonaAntecedentes, removePersonaAntecedentes } = personPastSlice.actions;
export const defaultPersonaAntecedentes = [{
    id: 0,
    idPersona: 0,
    numero: 0,
    idTipoAntecedente: 0,
    antecente: "",
    fechaRegistro: null,
    usuarioRegistro: null,
    fechaModificacion: null,
    usuarioModificacion: null,
}]
export default personPastSlice.reducer;
